import React from "react"

import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import ReactMarkdown from 'react-markdown'

import Image from "./image"
import Button from "./button"
import Collapse from "./collapse"

export default ({ content, className }) => {
    const renderOptions = {
        renderNode: {
            [BLOCKS.EMBEDDED_ENTRY]: (node) => {
                const type = node.data.target.sys.contentType.sys.contentful_id
                const fields = node.data.target.fields

                if (type === "image") {
                    // Resolve locale
                    // TODO handle localization properly
                    if( fields.image["en-US"].fields != null ) {
                        fields.image.file = {
                            url: fields.image["en-US"].fields.file["en-US"].url,
                        }
                    }
                    if(fields.imageCredit != null) {
                        fields.imageCredit = fields.imageCredit["en-US"]
                    }
                    return (
                        <Image content={ fields }/>
                    )
                }
                if (type === "button") {
                    // Resolve locale
                    // TODO handle localization properly

                    fields.buttonText = fields.buttonText ? fields.buttonText["en-US"] : ""
                    fields.buttonLink = fields.buttonText ? fields.buttonLink["en-US"] : ""

                    return (
                        <Button content={ fields }/>
                    )
                }
                if (type === "dropdown") {
                    fields.triggerText = fields.triggerText["en-US"]
                    fields.body.json = fields.body["en-US"]

                    return (
                        <Collapse content={ fields }/>
                    )
                }
                if (type === "markdown") {
                    // Resolve locale
                    // TODO handle localization properly
                    fields.mdBody = fields.mdBody["en-US"]
                    fields.color = fields.color["en-US"]

                    return (
                        <ReactMarkdown className={ fields.color } source={ fields.mdBody }/>
                    )
                }
            },
        },
    }

    if ( content != null)  {
        return (
            <div className={ className }>
              {documentToReactComponents(content.json, renderOptions)}
            </div>
        )
    }
    return (
        <div/>
    )
}
